import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { DocumentUrlService } from './document-url.service';

const service = new DocumentUrlService();

export interface DocumentUrlState {}

const DocumentUrlStore: Module<DocumentUrlState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getDocumentUrls(context, payload: { employeeId: number; ids: Array<number> }) {
         return await service.getDocumentUrls(payload.employeeId, { ids: payload.ids.join(',') });
      },
   },
};

export default DocumentUrlStore;
